import { ElementRef } from '@angular/core';
import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { BtnConfig } from '../../../model';

/**
 * * Componente de Botão do Apolo.
 */
@Component({
  selector: 'ui-btn',
  templateUrl: './btn.component.html',
  styleUrls: ['./btn.component.scss']
})
export class BtnComponent {

  constructor() { }

  /**
   * * Configuração do Botão.
   */
  @Input() btn: BtnConfig | undefined;

  /**
   * * Evento do clique do botão.
   */
  @Output() btnEvent = new EventEmitter<any>();


  @ViewChild('btn', {static: false}) button: ElementRef<HTMLButtonElement> | undefined;

  // ****************

  callBtnEvent(event: MouseEvent): void {
    this.btnEvent.emit(event);
  }

}
